<template>
    <dashboard-layout tit="브릿지">
        <template #topBtn>
            <expo-program-form @input="updateItem">
                <template #activator="{ attrs, on }">
                    <v-btn color="secondary" v-bind="attrs" v-on="on">프로그램 생성</v-btn>
                </template>
            </expo-program-form>
        </template>
        <template #contents>
            <v-sheet>
                <v-tabs class="v-tabs--underline mb-20 mb-lg-40">
                    <template v-for="{ value, text } in tabs">
                        <v-tab :to="`${baseUrl}/${value}`" :key="value">
                            {{ text }}
                        </v-tab>
                    </template>
                </v-tabs>
                <v-tabs-items :value="tab" class="fill-height">
                    <v-tab-item :value="TABS.employer.value">
                        <expo-program-list-filter class="mb-20 mb-lg-40" v-bind="{ loading }" />
                        <list-employer :isActive="tab == TABS.employer.value" v-on="{ setLoading }" :ref="TABS.employer.value" />
                    </v-tab-item>
                    <v-tab-item :value="TABS.host.value">
                        <expo-program-list-filter class="mb-20 mb-lg-40" v-bind="{ loading }" />
                        <list-host :isActive="tab == TABS.host.value" v-on="{ setLoading }" :ref="TABS.host.value" />
                    </v-tab-item>
                </v-tabs-items>
            </v-sheet>
        </template>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ExpoProgramForm from "./expo-program-form.vue";
import ExpoProgramListFilter from "@/components/dashboard/common/expo/program/expo-program-list-filter.vue";
import ListEmployer from "./list/list-employer.vue";
import ListHost from "./list/list-host.vue";

const TABS = {
    employer: { value: "employer", text: "참여 목록" },
    host: { value: "host", text: "생성 목록" },
};

const tabs = Object.values(TABS);

const baseUrl = "/dashboard/programs";
const tab__initial = tabs[0].value;

export default {
    components: {
        DashboardLayout,
        ExpoProgramForm,
        ExpoProgramListFilter,
        ListEmployer,
        ListHost,
    },
    props: {
        tab: { type: String, default: tab__initial },
    },
    data: () => ({
        tabs,
        TABS,
        baseUrl,

        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        "$route.path"() {
            this.syncPath();
        },
    },
    methods: {
        init() {
            this.loading = false;
        },
        async syncPath() {
            const path = `${baseUrl}/${this.tab}`;
            if (this.$route.path != path) this.$router.replace({ path });
        },
        updateItem(item) {
            if (this.tab !== "host") {
                this.$router.push(`${baseUrl}/host`);
            } else {
                this.$refs["host"]?.updateItem?.(item);
            }
        },
        setLoading(loading) {
            this.loading = loading;
        },
    },
};
</script>

<style>
</style>